import { gql } from '@apollo/client';

export default class AppReleaseMutate {
    static MARK_ALL_APP_RELEASES_AS_READ = gql`
        mutation markAllAppReleasesAsRead {
            markAllAppReleasesAsRead
        }
    `;
}
